import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

export type ThisApi = ApiDefinition['/creators/{creatorSlug}/courses']['GET'];

export const useCourses = (
  params: ThisApi['params'] | null,
  config?: UseNoodleSwrConfig<ThisApi['response']>,
): SWRResponse<ThisApi['response'], ApiError> => {
  const path = params ? buildPath<ThisApi>('/creators/{creatorSlug}/courses', params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useCourses` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getCourses = async ({ creatorSlug }: ThisApi['params']): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/creators/{creatorSlug}/courses', { creatorSlug });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getCourses;
